"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _boolModule = _interopRequireDefault(require("./bool.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function Bool(props) {
  var data = props.data,
    _props$yesKey = props.yesKey,
    yesKey = _props$yesKey === void 0 ? 'Yes' : _props$yesKey,
    _props$noKey = props.noKey,
    noKey = _props$noKey === void 0 ? 'No' : _props$noKey;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _boolModule["default"].common
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_boolModule["default"].wrapper, " ").concat(data && yesKey === 'Yes' && _boolModule["default"].success, "\n       ").concat(!data && noKey === 'Yes' && _boolModule["default"].error)
  }, data ? yesKey : noKey));
}
var _default = Bool;
exports["default"] = _default;